"use strict";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultContext = void 0;
/**
 * Returns a context instance in its default state.
 */
function getDefaultContext() {
    return {
        inherited: {
            visitedNodes: [],
            steps: [],
        },
    };
}
exports.getDefaultContext = getDefaultContext;
//# sourceMappingURL=context.js.map